import { UPDATE_SEGMENT, INSERT_SEGMENT, DELETE_SEGMENT } from "../actions/transcriptActions";

const SegmentsReducer = (state = {}, action) => {
    switch (action.type) {
    case UPDATE_SEGMENT: {
        let newSegments = [...state.segments];
        newSegments[action.index] = {...newSegments[action.index], htmlContent: null, ...action.segment};
        return { ...state, segments: newSegments };
    }
    case INSERT_SEGMENT: {
        let newSegments = [...state.segments];
        let newSegment = action.segment;
        newSegment.id = state.next_segment_id;
        newSegments.splice(action.index, 0, newSegment);
        return { ...state, segments: newSegments, next_segment_id: state.next_segment_id + 1 };
    }
    case DELETE_SEGMENT: {
        if (action.index <= 0) {
            break;
        }
        let newSegments = [...state.segments];
        const removedSegment = newSegments[action.index];
        newSegments.splice(action.index, 1);
        const joinedSegment = newSegments[action.index - 1];
        joinedSegment.appendContent && setTimeout(() => joinedSegment.appendContent(removedSegment.content), 0);
        newSegments[action.index - 1] = { ...joinedSegment };
        return { ...state, segments: newSegments };
    }
    default:
        return state;
    }
};

export default SegmentsReducer;
